import { useState } from "react";
import ClientQuotes from "./ClientQuotes";
import "./ClientDashboard.css"

import { Truck, Package, AlertTriangle, FileText, MapPin } from "lucide-react";
import UserTransportOrders from "./UserTransportOrders";
import UserProofOfDelivery from "./UserProofOfDelivery";
import UserIssues from "./UserIssues";
import PartialDispatchMap from "../Tracking/PartialDispatchMap";

export default function ClientDashboard() {
  const [activeTab, setActiveTab] = useState("tracking");

  const tabs = [
    { id: "tracking", label: "In Transit", icon: MapPin },
    { id: "orders", label: "Orders", icon: Package },
    { id: "quotes", label: "Transport Requests", icon: Truck },
    { id: "issues", label: "Issues", icon: AlertTriangle },
    { id: "pod", label: "Bills & Payments", icon: FileText },
  ];

  return (
    <div className="tp-client-dashboard">

      {/* Toggle Buttons */}
      <div className="tp-tabs-container">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`tab-btn ${activeTab === tab.id ? "active" : ""}`}
            >
              <Icon size={20} />
              <span>{tab.label}</span>
            </button>
          );
        })}
      </div>

      {/* Content Area */}
      <div className="tp-dashboard-content">

        {activeTab === "tracking" && (
          <div className="tp-placeholder-content">
            {activeTab === "tracking" && <PartialDispatchMap />}
          </div>
        )}
        {activeTab === "orders" && (
          <div className="">
            {activeTab === "orders" && <UserTransportOrders />}
          </div>
        )}

        {activeTab === "quotes" && <ClientQuotes />}
        {activeTab === "issues" && (
          <div className="tp-placeholder-content">
            {activeTab === "issues" && <UserIssues />}
          </div>
        )}

        {activeTab === "pod" && (
          <div className="tp-placeholder-content">
            {activeTab === "pod" && <UserProofOfDelivery />}
          </div>
        )}


        {/* Default Message when nothing is selected (optional) */}
        {!activeTab && (
          <div className="tp-empty-state">
            <p>Select a section from above to view details</p>
          </div>
        )}
      </div>
    </div>
  );
}